import CBAA1020ResponseModel from '@/api/data/CBA/CBAG1020/CBAA1020ResponseModel'
import CBAA1020RequestModel from '@/api/data/CBA/CBAG1020/CBAA1020RequestModel'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'

/**
 * 運用の方法の公表（個人型）（第一生命の個人型Vプランα）サービス
 */
export default class CBAG1020Service {
  public async callAPICBAA1020(
    rkPlnCd: string
  ): Promise<CBAA1020ResponseModel> {
    const cbaa1020RequestModel = new CBAA1020RequestModel()
    cbaa1020RequestModel.rkPlnCd = rkPlnCd

    const cbaa1020ResponseModel: CBAA1020ResponseModel = <
      CBAA1020ResponseModel
    > await RestService.post(ApiUrlConstants.CBAA1020, cbaa1020RequestModel)
    return cbaa1020ResponseModel
  }
}
